export const payment = {
    testFinalCashUrl    : "http://localhost:5000/tryshiftt/us-central1/api/v1/finalizeCashPayment",
    createPayment       : "https://us-central1-tryshiftt.cloudfunctions.net/api/v1/createPayment",
    finalUrl     : "https://us-central1-tryshiftt.cloudfunctions.net/api/v1/finalizePayment",
    finalCashUrl : "https://us-central1-tryshiftt.cloudfunctions.net/api/v1/finalizeCashPayment",
    PAY_BY_CASH : 0,
	PAY_BY_CARD : 1,
	PAY_BY_KNET : 2
}